import { useTranslation } from "react-i18next";
import { preferencesPageInnerClassName } from "./layout";
import MailDeliveryPreferencesForm from "./MailDeliveryPreferencesForm";
import MailingAddressForm from "./MailingAddressForm";
import { Spinner } from "@dsaui/components";
import { cn } from "@dsaui/utils";
import { PageShell } from "components/PageShell";
import { PageTitle } from "components/PageTitle";
import type * as API from "lib/api/types";
import type { FormValues } from "components/ProfileForm/support";

export interface Props {
  profile?: FormValues;
  profileReady: boolean;
  ready: boolean;
  submitProfileUpdate: (payload: API.UserProfilePayload) => Promise<void>;
}

const PreferencesLayout = ({
  profile,
  profileReady,
  ready,
  submitProfileUpdate,
}: Props) => {
  const { t } = useTranslation();

  return (
    <PageShell className={cn(preferencesPageInnerClassName, "px-0")}>
      <PageTitle>{t("pages.preferences")}</PageTitle>
      {profileReady && profile ? (
        <>
          <MailingAddressForm
            profile={profile}
            ready={ready}
            submitProfileUpdate={submitProfileUpdate}
          />
          <MailDeliveryPreferencesForm
            profile={profile}
            ready={ready}
            submitProfileUpdate={submitProfileUpdate}
          />
        </>
      ) : (
        <Spinner className="mt-3 self-center" />
      )}
    </PageShell>
  );
};

export default PreferencesLayout;
